import { deviceType } from 'react-device-detect';

function getDeviceType() {
  switch (deviceType) {
    case 'mobile':
      return 'Mobile';
    case 'tablet':
      return 'Tablet';
    case 'browser':
      return 'Desktop';
    default:
      return '';
  }
}

export { getDeviceType };
